import React, { useState, useEffect, useContext } from "react";
import axios from 'axios'

import { GlobalContext, HOST } from "./context/GlobalContext"

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Table from 'react-bootstrap/Table'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import Select from 'react-select';

import './App.css';
import { X } from "react-bootstrap-icons";

const REMISION_PARTIDAS_UPDATE_API = HOST + '/api/inv/remisionDetalle/update'

const CURRENCY_FORMAT = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

function RemisionPartidas({ remision, readOnly, setShowDetail, setTotalRequest, setTotalGet, remisionOrden, setRemisionOrden }) {
  const { librosProvList, partidasList, remisionPartidasList, rol, token, setShowMesage, setMailTitle, setMailBody, setCallback, setGlobalLoading, setPartidasList, getLibrosProv, getRemisiones, getPartidas, getPartidasRemision } = useContext(GlobalContext);

  const [inputFields, setInputFields] = useState([])
  const [optionsLibros, setOptionsLibros] = useState([])
  const [isDisabled, setIsDisabled] = useState(false)
  const [comentarios, setComentarios] = useState([])

  useEffect(() => {
    setInputFields([])
    setOptionsLibros([])
    setPartidasList([])

    setComentarios(remision.comentarios)
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if(parseInt(rol) === 1 || remision.estatusDevolucion !== 'en_espera') setIsDisabled(true)

    getLibrosProv( remision.idProveedor )
  }, [remision]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if( librosProvList.length > 0 ){
      getPartidas( remision.idOrden )
      getPartidasRemision( remision.idRemision )
    }
  }, [librosProvList]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setInputFields([])
    let result = []
    let totalRes = 0
    let totalGet = 0
    let remSubtotal = 0
    let remTotal = 0
    let remOrden = JSON.parse(JSON.stringify(remisionOrden))

    if( partidasList.length > 0 ) {
      if( remisionPartidasList.length > 0 ){
        let clone = remisionPartidasList

        clone.map( item => {
          let partida = partidasList.find(o => o.idPartida === item.idOrdenDetalle)

          if(partida) {
            item.ordenDetalle = partida 
            totalRes += item.ordenDetalle.cantidad
            totalGet += item.cantidad

            let amount = item.cantidad * item.ordenDetalle.precio
            remSubtotal += amount
            remTotal += getDiscount( amount, item.ordenDetalle.descuento, remOrden.descuentoProv )
          }
          
          return null
        })

        remOrden.subtotal = remSubtotal
        remOrden.descuento = remSubtotal - remTotal
        remOrden.total = remTotal
        result = clone
      } else {
        let elements = []

        partidasList.map( item => {
          totalRes += item.cantidad

          elements.push({
            cantidad: item.cantidad,
            comentarios: '-',
            precio: item.precio,
            estatus: true,
            idOrdenDetalle: item.idPartida,
            idRemision: remision.idRemision,
            idRemisionDetalle: null,
            ordenDetalle: item
          })

          return null
        })

        result = elements
      }

      setTotalGet(totalGet)
      setTotalRequest( totalRes )
      setRemisionOrden( remOrden )
      setInputFields(result)
      //console.log("inputs", result, totalRes)
    }

  }, [remisionPartidasList, partidasList]); // eslint-disable-line react-hooks/exhaustive-deps

  /*
  useEffect(() => {
    setInputFields([])

    let clone = remisionPartidasList
    let books = []
    
    console.log("listas", partidasList, optionsLibros)
    if( partidasList.length > 0 && optionsLibros.length === 0 && librosProvList.length > 0 ) {
      partidasList.map( item => {
        let element = getNombreLibroProv( item.idLibro )

        if(element)
          books.push({ value: element.idLibro, label: element.titulo, item: item })
      })

      setOptionsLibros( books )
    }

    if( remisionPartidasList.length > 0 && partidasList.length > 0 ){
      clone.map( item => {

        let partida = partidasList.find(o => o.idPartida === item.idOrdenDetalle)

        if(partida){
          item.ordenDetalle = partida
          item.disabled = true
        }
  
        return null
      })

      setInputFields(clone)
    }

  }, [partidasList, remisionPartidasList]); // eslint-disable-line react-hooks/exhaustive-deps
  */

  const getDiscount = ( amount, singleDisc, globalDisc ) => {
    let result = amount

    if( singleDisc > 0 )
      result = result - (result * ( singleDisc / 100 ))

    if( globalDisc > 0 )
      result = result - (result * ( globalDisc / 100 ))

    return result
  }

  const updatePartida = (e) => {
    e.preventDefault();
    setGlobalLoading( true )

    inputFields.map(item => {
      //delete item.disabled
      delete item.ordenDetalle
      delete item.exceeded

      return null
    })

    let json = { comentarios: comentarios, inputFields: inputFields }
    
    console.log("inputFields to save", json)

    axios.post(REMISION_PARTIDAS_UPDATE_API, json, {
			headers: { 'content-type': 'application/json', 'Authentication': token }
    }).then(result => {
      console.log("result update", result.data)
      //getPartidasRemision(remision.idRemision)
      getRemisiones()
      setShowDetail(false)
      setGlobalLoading( false )
    })
    .catch(error => {
      console.log("error", error.message)
      setShowMesage(true)
      setMailTitle('Error')
      setMailBody('Ocurrió un error al guardar tu registro. Por favor intentalo mas tarde.')
      setCallback(false)
      setGlobalLoading( false )
    })
  }

  const handleFormChange = (index, item, event) => {
    let data = [...inputFields];
    data[index][event.target.name] = event.target.value;

    if( event.target.name === 'cantidad') {
      let max = 0
      let exceeded  = false

      if(item.ordenDetalle.cantidadSurtida && item.ordenDetalle.cantidadSurtida > 0)
        max = item.ordenDetalle.cantidad - item.ordenDetalle.cantidadSurtida
      else max = item.ordenDetalle.cantidad

      if( event.target.value > max ) exceeded  = true

      data[index]['exceeded'] = exceeded
    }

    setInputFields(data);
  }

  const addFields = (item) => {
    let newfield = { idRemisionDetalle: null, idRemision: remision.idRemision, idOrdenDetalle: item.item.idPartida, cantidad: 0, comentarios: null, estatus: true, ordenDetalle: item.item  }
    console.log('add item', item, newfield)
    setInputFields([...inputFields, newfield])
  }

  const removeFields = (index) => {
    let data = [...inputFields];
    data.splice(index, 1)
    setInputFields(data)
  }

  const getBookName = (idLibro) => {
    if(librosProvList.length > 0) {
      let result = librosProvList.find( o => o.idLibro === idLibro);
      return result ? result.titulo : ''
    }
    return ''
  }

  return (
    <div>
      <Form id="partidaForm" onSubmit={ updatePartida }>
        <Container>
          <Row>
            <div>
              { !readOnly && parseInt(rol) === 2 && !isDisabled && 
                <Container>
                  <Row>
                    <Col md={ 10 }>
                      {/* <Form.Group className='mb-3'>
                        <Select
                          className="basic-single"
                          classNamePrefix="select"
                          placeholder="Libros..."
                          isClearable={true} 
                          isSearchable={true}
                          name="color"
                          value={null}
                          options={optionsLibros}
                          onChange={ (e) => addFields(e) }
                        />
                      </Form.Group> */}
                    </Col>
                    <Col md={9} className="pb-3">
                      <FloatingLabel label="Comentarios Generales">
                        <Form.Control as="textarea" rows={3} value={ comentarios } onChange={ (e) => setComentarios( e.target.value ) } placeholder="" />
                      </FloatingLabel>
                    </Col>
                    <Col md={ 3 }>
                      { inputFields.length > 0 &&
                        <div align="center">
                          <button type="submit" className="grl-btn">{ 'Guardar' }</button>
                        </div>
                      }
                    </Col>
                  </Row>
                </Container>
              }

              <Container>
                { inputFields.map((item, index) => {
                  
                  if(readOnly) {
                    if( remisionPartidasList.length > 0 )
                      return <>
                        <Row> <Col> <div style={{ paddingTop: '10px' }}><b>{ '#' + ((index+1) < 10 ? '0' + (index+1) : (index+1)) + ' ' + getBookName( item.ordenDetalle.idLibro ) }</b></div> </Col> </Row>
                        {/*<Row> <Col> <div style={{ paddingTop: '0px' }}><b>Cantidad Solicitada: </b> { item.ordenDetalle.cantidad }</div> </Col> </Row>*/}
                        <Row index={`partida_${index}`} className="align-items-center">
                          
                          <Col md={4}>
                            <div className="desc-form" style={{ color: '#ae0107' }}> Solicitados </div>
                            <div>{ item.ordenDetalle.cantidad }</div>
                          </Col>
                          <Col md={4}> 
                            <div className="desc-form" style={{ color: '#ae0107' }}> Recibidos </div>
                            <div>{ item.cantidad }</div>
                          </Col>
                          <Col md={4}> 
                            <div className="desc-form" style={{ color: '#ae0107' }}> Precio </div>
                            <div>{ item.precio }</div>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={12}>
                            <div className="desc-form" style={{ color: '#ae0107' }}> Comentarios </div>
                            <div>{ item.comentarios }</div>
                          </Col>
                        </Row>
                      </>
                  } else if(item.ordenDetalle) {
                    return <>
                      <Row> <Col> <div style={{ paddingTop: '10px' }}><b>{ '#' + ((index+1) < 10 ? '0' + (index+1) : (index+1)) + ' ' + getBookName( item.ordenDetalle.idLibro ) }</b></div> </Col> </Row>
                      <Row> <Col> <div style={{ paddingTop: '0px' }}><b>Cantidad Solicitada: </b> { item.ordenDetalle.cantidad }</div> </Col> </Row>
                      <Row index={`partida_${index}`} className="align-items-center">
                        
                        <Col md={3}>
                          <Form.Group className='mb-3'>
                            <FloatingLabel label="Recibidos">
                              <Form.Control required disabled={isDisabled} type='number' min="1" name={'cantidad'} value={ item.cantidad } onChange={event => handleFormChange(index, item, event)} placeholder="" />
                            </FloatingLabel>
                          </Form.Group>
                        </Col>
                        <Col md={3}>
                          <Form.Group className='mb-3'>
                            <FloatingLabel label="Precio">
                              <Form.Control required disabled={isDisabled} type='text' name={'precio'} value={ item.precio } onChange={event => handleFormChange(index, item, event)} placeholder="" />
                            </FloatingLabel>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group className='mb-3'>
                            <FloatingLabel label="Comentarios">
                              <Form.Control required disabled={isDisabled} type='text' name={'comentarios'} value={ item.comentarios } onChange={event => handleFormChange(index, item, event)} placeholder="" />
                            </FloatingLabel>
                          </Form.Group>
                        </Col>
                        {/* <Col md={1}>
                          { parseInt(rol) === 2 && !item.disabled && <X onClick={() => removeFields(index)} className="table-icon" /> }
                        </Col> */}
                        { item.exceeded &&<Col md={12}> <Form.Text style={{ color: '#aa2d1f' }}> Nota: La Cantidad ingresada supera la cantidad solicitada </Form.Text> </Col> }
                      </Row>
                    </>
                  } else return <div></div>

                  }) 
                }
                  {/*<Table responsive>
                    <thead>
                      <tr>
                        <th>Libro</th>
                        <th>Descripcion</th>
                        <th>Cant. Solicitada</th>
                        <th>Precio</th>
                        <th>Cant. Recibida</th>
                        <th>Comentarios</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      { inputFields.length === 0 && 
                        <tr>
                          <td colSpan="6"> <div>Sin registros</div> </td>
                        </tr>
                      }
                      { inputFields.map((item, index) => {
                        if(item.ordenDetalle) {
                          let max = 0

                          if(item.ordenDetalle.cantidadSurtida && item.ordenDetalle.cantidadSurtida > 0)
                            max = item.ordenDetalle.cantidad - item.ordenDetalle.cantidadSurtida
                          else max = item.ordenDetalle.cantidad

                          return <tr key={ item.ordenDetalle.idPartida }>
                            <td> 
                              <b>{ '#' + ((index+1) < 10 ? '0' + (index+1) : (index+1)) + ' ' + getBookName( item.ordenDetalle.idLibro ) }</b>
                            </td>
                            <td> 
                              { item.ordenDetalle.descripcion } 
                            </td>
                            <td> 
                              { item.ordenDetalle.cantidad }
                            </td>
                            <td> 
                              { item.ordenDetalle.precio }
                            </td>
                            <td>
                              <Form.Group className='mb-3'>
                                <FloatingLabel label="Cantidad">
                                  <Form.Control required disabled={isDisabled || item.disabled} type='number' min="1" max={ max } name={'cantidad'} value={ item.cantidad } onChange={event => handleFormChange(index, event)} placeholder="" />
                                </FloatingLabel>
                              </Form.Group>
                            </td>
                            <td>
                              <Form.Group className='mb-3'>
                                <FloatingLabel label="Comentarios">
                                  <Form.Control required disabled={isDisabled || item.disabled} type='text' name={'comentarios'} value={ item.comentarios } onChange={event => handleFormChange(index, event)} placeholder="" />
                                </FloatingLabel>
                              </Form.Group>
                            </td>
                            <td align="right"> 
                              { parseInt(rol) === 2  && item.estatus &&   
                                <>
                                  <OverlayTrigger placement="top" delay={{ show: 250, hide: 400 }} overlay={<Tooltip>Remover</Tooltip>}>
                                    <X onClick={ () => removeFields(index) } className="table-icon" />
                                  </OverlayTrigger>
                                </>
                              }
                            </td>
                          </tr>
                        } else return <div></div>
                       }) }
                    </tbody>
                  </Table>*/}
              </Container>

            </div>
          </Row>
        </Container>
      </Form>
    </div>
  );
}

export default RemisionPartidas;
